import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsOfService: React.FC = () => {
    const { t, i18n } = useTranslation();
    const isVi = i18n.language.startsWith('vi');
    return (
        <div className="flex flex-col items-center px-6 text-[#333] md:pt-10 pt-[73px] h-auto">
            <h1 className="md:text-5xl text-4xl md:text-6xl font-light mb-10">{t("legal.terms.title")}</h1>
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.terms.agreementTitle")}</h2>
                <div>
                    <p className="font-semibold">{t("legal.terms.agreementBody1")}</p>
                    <ul className="list-disc list-inside">
                        <li>{t("legal.terms.agreementLi1")}</li>
                        <li>{t("legal.terms.agreementLi2")}</li>
                    </ul>
                </div>

                <div>
                    <p className="font-semibold">{t("legal.terms.agreementBody2")}</p>
                    <ol className="list-decimal list-inside">
                        <li>{t("legal.terms.agreementLi3")}</li>
                        <li>{t("legal.terms.agreementLi4")}</li>
                    </ol>
                </div>

                <div>
                    <p className="font-semibold">{t("legal.terms.agreementBody3")}</p>
                    <ul className="list-disc list-inside">
                        <li>{t("legal.terms.agreementLi5")}</li>
                        <li>{t("legal.terms.agreementLi6")}</li>
                        <li>{t("legal.terms.agreementLi7")}</li>
                    </ul>
                    <p>
                        {t("legal.terms.agreementBody4")}
                    </p>
                </div>

                <div>
                    <p className="font-semibold">{t("legal.terms.agreementBody5")}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec1Title')}</h2>
                    <p>{t('legal.terms.sec1Body')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec2Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec21Title')}</h3>
                    <p>{t('legal.terms.sec21Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec22Title')}</h3>
                    <p>{t('legal.terms.sec22Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec22LiA')}</li>
                        <li>{t('legal.terms.sec22LiB')}</li>
                        <li>{t('legal.terms.sec22LiC')}</li>
                        <li>{t('legal.terms.sec22LiD')}</li>
                        <li>{t('legal.terms.sec22LiE')}</li>
                        <li>{t('legal.terms.sec22LiF')}</li>
                        <li>{t('legal.terms.sec22LiG')}</li>
                        <li>{t('legal.terms.sec22LiH')}</li>
                        <li>{t('legal.terms.sec22LiI')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec23Title')}</h3>
                    <p>{t('legal.terms.sec23Body')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec3Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec31Title')}</h3>
                    <p>{t('legal.terms.sec31Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec32Title')}</h3>
                    <p>{t('legal.terms.sec32Body')}</p>
                    <h3 className="font-semibold mt-2">{t('legal.terms.sec33Title')}</h3>
                    <p>{t('legal.terms.sec33Body')}</p>
                    <h3 className="font-semibold mt-2">{t('legal.terms.sec34Title')}</h3>
                    <p>{t('legal.terms.sec34Body')}</p>
                </div>
                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec4Title')}</h2>
                    <p>{t('legal.terms.sec4Intro')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec41Title')}</h3>
                    <p>{t('legal.terms.sec41Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec42Title')}</h3>
                    <p>{t('legal.terms.sec42Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec43Title')}</h3>
                    <p>{t('legal.terms.sec43Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec44Title')}</h3>
                    <p>{t('legal.terms.sec44Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec45Title')}</h3>
                    {isVi ? (
                        <>
                            <p>{t('legal.terms.sec45ViLead')}</p>
                            <ul className="list-disc list-inside ml-6">
                                <li>{t('legal.terms.sec45ViLi1')}</li>
                                <li>{t('legal.terms.sec45ViLi2')}</li>
                            </ul>
                            <p className="mt-2">{t('legal.terms.sec45ViFooter')}</p>
                        </>
                    ) : (
                        <>
                            <p>{t('legal.terms.sec45Para1')}</p>
                            <ul className="list-disc list-inside">
                                <li>{t('legal.terms.sec45LiA')}</li>
                                <li>
                                    {t('legal.terms.sec45LiB')}
                                    <ul className="list-disc list-inside ml-6 mt-1">
                                        <li>{t('legal.terms.sec45SubI')}</li>
                                        <li>{t('legal.terms.sec45SubII')}</li>
                                    </ul>
                                </li>
                            </ul>
                            <p className="mt-2">{t('legal.terms.sec45Para2')}</p>
                        </>
                    )}
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec5Title')}</h2>
                    <p>{t('legal.terms.sec5Intro')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec51Title')}</h3>
                    <p>{t('legal.terms.sec51P1')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec51Li1')}</li>
                        <li>{t('legal.terms.sec51Li2')}</li>
                        <li>{t('legal.terms.sec51Li3')}</li>
                        <li>
                            {t('legal.terms.sec51Li4Prefix')}
                            <ul className="list-disc list-inside ml-6">
                                <li>{t('legal.terms.sec51Li4a')}</li>
                                <li>{t('legal.terms.sec51Li4b')}</li>
                                <li>{t('legal.terms.sec51Li4c')}</li>
                            </ul>
                        </li>
                    </ul>
                    <p className="mt-2">{t('legal.terms.sec51P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec52Title')}</h3>
                    <p>{t('legal.terms.sec52P1')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec52Li1')}</li>
                        <li>{t('legal.terms.sec52Li2')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec53Title')}</h3>
                    <p>{t('legal.terms.sec53Body')}</p>
                </div>
                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec6Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec61Title')}</h3>
                    <p>{t('legal.terms.sec61Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec62Title')}</h3>
                    <p>{t('legal.terms.sec62Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec63Title')}</h3>
                    <p>{t('legal.terms.sec63Body')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec7Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec71Title')}</h3>
                    <p>{t('legal.terms.sec71Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec72Title')}</h3>
                    <p>{t('legal.terms.sec72P1')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec72Li1')}</li>
                        <li>{t('legal.terms.sec72Li2')}</li>
                        <li>{t('legal.terms.sec72Li3')}</li>
                    </ul>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec8Title')}</h2>
                    <p>{t('legal.terms.sec8Body')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec9Title')}</h2>
                    <p>{t('legal.terms.sec9P1')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec9Li1')}</li>
                        <li>{t('legal.terms.sec9Li2')}</li>
                        <li>{t('legal.terms.sec9Li3')}</li>
                    </ul>
                </div>
                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec10Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec101Title')}</h3>
                    <p>{t('legal.terms.sec101aLabel')}</p>
                    <p>{t('legal.terms.sec101aBody')}</p>
                    <p>{t('legal.terms.sec101bLabel')}</p>
                    <p>{t('legal.terms.sec101bBody')}</p>
                    <p>{t('legal.terms.sec101cLabel')}</p>
                    <p>{t('legal.terms.sec101cIntro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec101cLi1')}</li>
                        <li>{t('legal.terms.sec101cLi2')}</li>
                    </ul>
                    <p>{t('legal.terms.sec101cRenewalNote')}</p>
                    <p>{t('legal.terms.sec101dLabel')}</p>
                    <p>{t('legal.terms.sec101dBody')}</p>
                    <p>{t('legal.terms.sec101eLabel')}</p>
                    <p>{t('legal.terms.sec101eBody')}</p>
                    <p>{t('legal.terms.sec101fLabel')}</p>
                    <p>{t('legal.terms.sec101fBody')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec102Title')}</h3>
                    <p>{t('legal.terms.sec102aLabel')}</p>
                    <p>{t('legal.terms.sec102aBody')}</p>
                    <p>{t('legal.terms.sec102bLabel')}</p>
                    <p>{t('legal.terms.sec102bBody')}</p>
                    <p>{t('legal.terms.sec102cLabel')}</p>
                    <p>{t('legal.terms.sec102cBody')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec103Title')}</h3>
                    <p>{t('legal.terms.sec103Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec104Title')}</h3>
                    <p>{t('legal.terms.sec104Body')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec11Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec111Title')}</h3>
                    <p>{t('legal.terms.sec111Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec111LiA')}</li>
                        <li>{t('legal.terms.sec111LiB')}</li>
                        <li>{t('legal.terms.sec111LiC')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec112Title')}</h3>
                    <p>{t('legal.terms.sec112P1')}</p>
                    <p>{t('legal.terms.sec112P2')}</p>
                    <p>{t('legal.terms.sec112P3')}</p>
                    <p>{t('legal.terms.sec112P4')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec113Title')}</h3>
                    <p>{t('legal.terms.sec113Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec113LiA')}</li>
                        <li>{t('legal.terms.sec113LiB')}</li>
                        <li>{t('legal.terms.sec113LiC')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec114Title')}</h3>
                    <p>{t('legal.terms.sec114P1')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec114Li1')}</li>
                        <li>{t('legal.terms.sec114Li2')}</li>
                        <li>{t('legal.terms.sec114Li3')}</li>
                    </ul>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec12Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec121Title')}</h3>
                    <p>{t('legal.terms.sec121Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec122Title')}</h3>
                    <p>{t('legal.terms.sec122P1')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec122Li1')}</li>
                        <li>{t('legal.terms.sec122Li2')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec123Title')}</h3>
                    <p>{t('legal.terms.sec123Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec123LiA')}</li>
                        <li>{t('legal.terms.sec123LiB')}</li>
                        <li>{t('legal.terms.sec123LiC')}</li>
                    </ul>
                    <p>{t('legal.terms.sec123P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec124Title')}</h3>
                    <p>{t('legal.terms.sec124Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec124LiA')}</li>
                        <li>{t('legal.terms.sec124LiB')}</li>
                        <li>{t('legal.terms.sec124LiC')}</li>
                    </ul>
                    <p>{t('legal.terms.sec124P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec125Title')}</h3>
                    <p>{t('legal.terms.sec125Intro')}</p>
                    <p>{t('legal.terms.sec125List')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec13Title')}</h2>
                    <p>{t('legal.terms.sec13P1')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec13Li1')}</li>
                        <li>{t('legal.terms.sec13Li2')}</li>
                    </ul>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec14Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec141Title')}</h3>
                    <p>{t('legal.terms.sec141Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec141Li1')}</li>
                        <li>{t('legal.terms.sec141Li2')}</li>
                        <li>{t('legal.terms.sec141Li3')}</li>
                        <li>{t('legal.terms.sec141Li4')}</li>
                        <li>{t('legal.terms.sec141Li5')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec142Title')}</h3>
                    <p>{t('legal.terms.sec142P1')}</p>
                    <p>{t('legal.terms.sec142P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec143Title')}</h3>
                    <p>{t('legal.terms.sec143Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec143LiA')}</li>
                        <li>{t('legal.terms.sec143LiB')}</li>
                        <li>{t('legal.terms.sec143LiC')}</li>
                    </ul>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec15Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec151Title')}</h3>
                    <p>{t('legal.terms.sec151Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec151LiA')}</li>
                        <li>{t('legal.terms.sec151LiB')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec152Title')}</h3>
                    <p>{t('legal.terms.sec152Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec152LiA')}</li>
                        <li>{t('legal.terms.sec152LiB')}</li>
                        <li>{t('legal.terms.sec152LiC')}</li>
                    </ul>
                    <p>{t('legal.terms.sec152P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec153Title')}</h3>
                    <p>{t('legal.terms.sec153P1')}</p>
                    <p>{t('legal.terms.sec153P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec154Title')}</h3>
                    <p>{t('legal.terms.sec154Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec154LiA')}</li>
                        <li>{t('legal.terms.sec154LiB')}</li>
                        <li>{t('legal.terms.sec154LiC')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec155Title')}</h3>
                    <p>{t('legal.terms.sec155Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec155LiA')}</li>
                        <li>{t('legal.terms.sec155LiB')}</li>
                        <li>{t('legal.terms.sec155LiC')}</li>
                        <li>{t('legal.terms.sec155LiD')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec156Title')}</h3>
                    <p>{t('legal.terms.sec156Body')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec16Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec161Title')}</h3>
                    <p>{t('legal.terms.sec161Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec161LiA')}</li>
                        <li>{t('legal.terms.sec161LiB')}</li>
                    </ul>
                    <p>{t('legal.terms.sec161P2')}</p>
                    <p>{t('legal.terms.sec161P3')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec162Title')}</h3>
                    <p>{t('legal.terms.sec162Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec162LiA')}</li>
                        <li>{t('legal.terms.sec162LiB')}</li>
                    </ul>
                    <p>{t('legal.terms.sec162P2')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec162SubLi1')}</li>
                        <li>{t('legal.terms.sec162SubLi2')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec163Title')}</h3>
                    <p>{t('legal.terms.sec163Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec163LiA')}</li>
                        <li>{t('legal.terms.sec163LiB')}</li>
                        <li>{t('legal.terms.sec163LiC')}</li>
                        <li>{t('legal.terms.sec163LiD')}</li>
                    </ul>
                    <p>{t('legal.terms.sec163P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec164Title')}</h3>
                    <p>{t('legal.terms.sec164P1')}</p>
                    <p>{t('legal.terms.sec164P2')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec17Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec171Title')}</h3>
                    <p>{t('legal.terms.sec171P1')}</p>
                    <p>{t('legal.terms.sec171P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec172Title')}</h3>
                    <p>{t('legal.terms.sec172P1')}</p>
                    <p>{t('legal.terms.sec172P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec173Title')}</h3>
                    <p>{t('legal.terms.sec173P1')}</p>
                    <p>{t('legal.terms.sec173P2')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec174Title')}</h3>
                    <p>{t('legal.terms.sec174Intro')}</p>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec174Li1')}</li>
                        <li>{t('legal.terms.sec174Li2')}</li>
                    </ul>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec18Title')}</h2>
                    <p>{t('legal.terms.sec18Body')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec19Title')}</h2>
                    <p>{t('legal.terms.sec19P1')}</p>
                    <p>{t('legal.terms.sec19P2')}</p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-[#3A57FF]">{t('legal.terms.sec20Title')}</h2>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec201Title')}</h3>
                    <p>{t('legal.terms.sec201Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec202Title')}</h3>
                    <p>{t('legal.terms.sec202Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec203Title')}</h3>
                    <ul className="list-disc list-inside">
                        <li>{t('legal.terms.sec203LiA')}</li>
                        <li>{t('legal.terms.sec203LiB')}</li>
                        <li>{t('legal.terms.sec203LiC')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec204Title')}</h3>
                    <ul className="list-disc list-inside">
                        <li>
                            {t('legal.terms.sec204LiAIntro')}
                            <ul className="list-disc list-inside mt-1 ml-6 space-y-1">
                                <li>{t('legal.terms.sec204LiI')}</li>
                                <li>{t('legal.terms.sec204LiII')}</li>
                            </ul>
                        </li>
                        <li>{t('legal.terms.sec204LiB')}</li>
                    </ul>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec205Title')}</h3>
                    {isVi ? (
                        <>
                            <p>{t('legal.terms.sec205ViP1')}</p>
                            <p>{t('legal.terms.sec205ViP2')}</p>
                        </>
                    ) : (
                        <ul className="list-disc list-inside">
                            <li>
                                {t('legal.terms.sec205LiAIntro')}
                                <ul className="list-disc list-inside ml-6">
                                    <li>{t('legal.terms.sec205LiAi')}</li>
                                    <li>{t('legal.terms.sec205LiAii')}</li>
                                    <li>{t('legal.terms.sec205LiAiii')}</li>
                                    <li>{t('legal.terms.sec205LiAiv')}</li>
                                </ul>
                            </li>
                            <li>{t('legal.terms.sec205LiB')}</li>
                            <li>{t('legal.terms.sec205LiC')}</li>
                        </ul>
                    )}

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec206Title')}</h3>
                    <p>{t('legal.terms.sec206Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec207Title')}</h3>
                    <p>{t('legal.terms.sec207Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec208Title')}</h3>
                    <p>{t('legal.terms.sec208Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec209Title')}</h3>
                    {isVi ? (
                        <ul className="list-disc list-inside">
                            <li>{t('legal.terms.sec209ViA')}</li>
                            <li>{t('legal.terms.sec209ViB')}</li>
                            <li>{t('legal.terms.sec209ViC')}</li>
                        </ul>
                    ) : (
                        <>
                            <ul className="list-disc list-inside">
                                <li>{t('legal.terms.sec209LiA')}</li>
                                <li>{t('legal.terms.sec209LiB')}</li>
                                <li>
                                    {t('legal.terms.sec209LiCIntro')}
                                    <ul className="list-disc list-inside ml-6">
                                        <li>{t('legal.terms.sec209LiCi')}</li>
                                        <li>
                                            {t('legal.terms.sec209LiCiiIntro')}
                                            <ul className="list-disc list-inside ml-8">
                                                <li>{t('legal.terms.sec209LiCiiA')}</li>
                                                <li>{t('legal.terms.sec209LiCiiB')}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <p className="mt-2">{t('legal.terms.sec209P2')}</p>
                        </>
                    )}

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec2010Title')}</h3>
                    <p>{t('legal.terms.sec2010Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec2011Title')}</h3>
                    <p>{t('legal.terms.sec2011Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec2012Title')}</h3>
                    <p>{t('legal.terms.sec2012Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec2013Title')}</h3>
                    {isVi ? (
                        <>
                            <p>{t('legal.terms.sec2013ViP1')}</p>
                            <p>{t('legal.terms.sec2013ViP2')}</p>
                        </>
                    ) : (
                        <>
                            <p>{t('legal.terms.sec2013P1')}</p>
                            <p>{t('legal.terms.sec2013P2')}</p>
                            <ul className="list-disc list-inside">
                                <li>{t('legal.terms.sec2013LiA')}</li>
                                <li>{t('legal.terms.sec2013LiB')}</li>
                                <li>{t('legal.terms.sec2013LiC')}</li>
                            </ul>
                        </>
                    )}

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec2014Title')}</h3>
                    <p>{t('legal.terms.sec2014Body')}</p>

                    <h3 className="font-semibold mt-2">{t('legal.terms.sec2015Title')}</h3>
                    <p>{t('legal.terms.sec2015Body')}</p>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
